import { QuickLeadForm } from "./quick-lead-form";

/**
 * Inline rendering of the same compact quote form, anchored at #quote,
 * placed above the footer. Lets users who scroll past the modal CTAs still
 * convert without opening a dialog.
 */
export function InlineQuoteSection({
  source = "Bottom Form",
  defaultService = "",
  title = "Get Your Free Quote",
}: {
  source?: string;
  defaultService?: string;
  title?: string;
}) {
  return (
    <section
      id="quote"
      aria-labelledby="quote-inline-title"
      className="bg-[var(--brand-light-gray)] py-16 md:py-20 scroll-mt-24"
    >
      <div className="mx-auto max-w-[480px] px-4">
        <div className="text-center mb-8">
          <p
            className="text-xs font-bold uppercase tracking-[0.18em] text-[var(--brand-red)] mb-2"
            style={{ fontFamily: "var(--font-display)" }}
          >
            Get Started
          </p>
          <h2
            id="quote-inline-title"
            className="text-3xl md:text-4xl font-bold uppercase text-[var(--brand-deep-blue)] tracking-tight"
            style={{ fontFamily: "var(--font-display)" }}
          >
            {title}
          </h2>
          <p className="mt-3 text-[var(--brand-charcoal)]/80 text-base">
            Takes about a minute. No obligation — we'll text or call you back fast.
          </p>
        </div>
        <QuickLeadForm showHeader={false} source={source} defaultService={defaultService} />
      </div>
    </section>
  );
}
